import React, { Suspense } from "react";
import { Link, Route, Routes } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import "./routes.css";

// Lazy load all components for better performance
const LandingPage = React.lazy(() => import("../LandingPage/LandingPage"));
const EdgeNexus = React.lazy(() => import("../EdgeNexus/edgeNexus"));
const Team = React.lazy(() => import("../OurTeam/Team"));
const Contact = React.lazy(() => import("../Contact/Contact"));
const Microsoft = React.lazy(() => import("../Microsoft/Microsoft"));
const Blog = React.lazy(() => import("../Blog/Blog"));
const Login = React.lazy(() => import("../Login/Login"));
const ForgotPassword = React.lazy(
  () => import("../ForgotPassword/ForgotPassword"),
);
const ResetPassword = React.lazy(
  () => import("../ResetPassword/ResetPassword"),
);
const AcceptInvitation = React.lazy(
  () => import("../AcceptInvitation/AcceptInvitation"),
);
const UserManagement = React.lazy(
  () => import("../UserManagement/UserManagement"),
);
const MobileApplications = React.lazy(
  () => import("../MobileApplications/MobileApplications"),
);
const AdminDashboard = React.lazy(
  () => import(/* webpackChunkName: "admin" */ "../AdminDashboard/AdminDash"),
);
const SoftwareDev = React.lazy(() => import("../SoftwareDev/SoftwareDev"));
const FiscalSolutions = React.lazy(
  () => import("../FiscalSolutions/FiscalSolutions"),
);
const BlogPostPage = React.lazy(() => import("../BlogPost/Post"));
const PowerPages = React.lazy(() => import("../PowerPages/PowerPages"));
const GSCGuestHouse = React.lazy(() => import("../GSC/GSC"));
const EGRC = React.lazy(() => import("../EGRC/EGRC"));
const OmniMart = React.lazy(() => import("../OmniMart/OmniMart"));
const Unsubscribe = React.lazy(() => import("../Unsubscribe/Unsubscribe"));
// Route-level loading state — the same instrument spinner used everywhere.
const PageLoader = () => (
  <div className="dis-route-loader">
    <span className="dis-spinner" />
    <span className="dis-mono">Loading</span>
  </div>
);

// 404
const NotFound = () => (
  <div className="dis-route-missing">
    <span className="dis-mono">Error 404</span>
    <h1 className="dis-display">Page not found.</h1>
    <p className="dis-lead dis-muted">
      The page you were looking for has moved or never existed.
    </p>
    <Link to="/" className="dis-btn dis-btn--light dis-btn--wide">
      Back to home
    </Link>
  </div>
);

const AllRoutes = () => {
  return (
    <>
      <Toaster
        position="top-center"
        reverseOrder={false}
        toastOptions={{
          // Toasts obey the same flat, hairline-delineated rules as the page.
          style: {
            background: "var(--ink-raised)",
            color: "var(--paper)",
            border: "1px solid var(--rule-dark)",
            borderRadius: "var(--r-button)",
            boxShadow: "none",
            fontFamily: "var(--font-display)",
            fontSize: "15px",
            letterSpacing: "-0.006em",
            padding: "12px 16px",
          },
          iconTheme: { primary: "var(--signal)", secondary: "var(--ink)" },
          error: {
            iconTheme: { primary: "var(--danger)", secondary: "var(--ink)" },
          },
        }}
      />
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="*" element={<NotFound />} />

          <Route path="/" element={<LandingPage />} />
          <Route path="/admin-login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/accept-invitation" element={<AcceptInvitation />} />
          <Route path="/user-management" element={<UserManagement />} />

          <Route path="edge-nexus" element={<EdgeNexus />} />
          <Route path="/team" element={<Team />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/microsoft-solutions" element={<Microsoft />} />
          <Route path="/blog-posts" element={<Blog />} />
          <Route path="/admin-dash" element={<AdminDashboard />} />
          <Route path="/software-dev" element={<SoftwareDev />} />
          <Route path="/fiscal-services" element={<FiscalSolutions />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/unsubscribe" element={<Unsubscribe />} />

          {/* <Route path="/software-products" element={<SoftwareProducts />} /> */}
          <Route path="/mobile-apps" element={<MobileApplications />} />
          <Route path="/power-pages" element={<PowerPages />} />
          <Route path="/gsc-guest-house" element={<GSCGuestHouse />} />
          <Route path="/egrc-solutions" element={<EGRC />} />
          <Route path="/omni-mart" element={<OmniMart />} />

          {/* Add more routes as needed */}
        </Routes>
      </Suspense>
    </>
  );
};

export default AllRoutes;
